module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-dd-2beced6f.png";